var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"20","viewBox":"0 96 960 960","width":"20"}},[_c('path',{attrs:{"d":"m291 720-51-51 240-240 240 240-51 51-189-189-189 189Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }